export default __webpack_public_path__ + "static/media/information-system.6479b57c.svg";